// Global Instructions Rule Applied!
//
// Calendar-quarter helpers shared by the Reports screen and Period
// Highlights (lifted out of DocumentReportsForm so the two pickers cannot
// drift). Quarter arithmetic is done by hand rather than with dayjs's quarter
// helpers: this app never calls dayjs.extend(quarterOfYear), so
// `startOf('quarter')` and `.quarter()` are not available and would silently
// return the date unchanged instead of failing.
import dayjs from 'dayjs'

export const QUARTER_DATE_FORMAT = 'YYYY-MM-DD'
// How many completed quarters the Quarter End picker offers.
export const QUARTER_END_OPTION_COUNT = 24

export function quarterOfMonth(month: number): number {
  return Math.floor(month / 3) + 1
}

export function quarterEnd(year: number, quarter: number): dayjs.Dayjs {
  // Month index of the quarter's last month, then its last day.
  return dayjs(new Date(year, quarter * 3 - 1, 1)).endOf('month')
}

export function lastCompletedQuarterEnd(): dayjs.Dayjs {
  const now = dayjs()
  const quarter = quarterOfMonth(now.month())
  return quarter === 1 ? quarterEnd(now.year() - 1, 4) : quarterEnd(now.year(), quarter - 1)
}

export function lastQuarterEnd(): string {
  return lastCompletedQuarterEnd().format(QUARTER_DATE_FORMAT)
}

/** The quarter end three months before a quarter-end date (YYYY-MM-DD). */
export function previousQuarterEnd(quarterEndDate: string): string {
  const end = dayjs(quarterEndDate)
  const quarter = quarterOfMonth(end.month())
  return (quarter === 1 ? quarterEnd(end.year() - 1, 4) : quarterEnd(end.year(), quarter - 1)).format(
    QUARTER_DATE_FORMAT
  )
}

/** Completed calendar quarter ends, most recent first, as {value,label}. */
export function quarterEndOptions(): Array<{ value: string; label: string }> {
  const options: Array<{ value: string; label: string }> = []
  let end = lastCompletedQuarterEnd()
  for (let i = 0; i < QUARTER_END_OPTION_COUNT; i += 1) {
    const quarter = quarterOfMonth(end.month())
    options.push({ value: end.format(QUARTER_DATE_FORMAT), label: `${end.year()} Q${quarter}` })
    end = quarter === 1 ? quarterEnd(end.year() - 1, 4) : quarterEnd(end.year(), quarter - 1)
  }
  return options
}

export function oneYearPriorQuarterEnd(): string {
  const last = lastCompletedQuarterEnd()
  const quarter = quarterOfMonth(last.month())
  return quarterEnd(last.year() - 1, quarter).format(QUARTER_DATE_FORMAT)
}
